import * as React from "react";
import { AddressDetailModel } from "../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { AddressDisplayFields } from "./AddressDisplayFields";

export interface IAddressDisplayProps {
    address: AddressDetailModel;

    title?: string;
}

export class AddressDisplay extends React.Component<IAddressDisplayProps, any> {
    constructor(props: IAddressDisplayProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <>
                {this.props.title && <h4>{this.props.title}</h4>}
                <AddressDisplayFields address={this.props.address} />
            </>
        );
    }
}
